import React, { useState, useEffect } from 'react';
import { useFileContext } from '../../ContextAPI/FileContext';
import './ToggleSwitch.css';
import { ManagerlApi } from '../../API/api';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { FaTrash, FaSpinner } from 'react-icons/fa'; // Import the spinner icon

const LasDividerTab = () => {
  const { setRunLasDivider } =
    useFileContext();
  const [folderPath, setFolderPath] = useState('');
  const [showCheckMark, setShowCheckMark] = useState(false);
  const [currentFolderId, setCurrentFolderId] = useState('');
  const [requests, setRequests] = useState([]);


  const extractFolderId = (url) => {
    const parts = url.split('/');
    return parts[parts.length - 1];
  };

  const handleRunLasDivider = async () => {
    const folderId = extractFolderId(folderPath);
    if (!folderId) {
      console.error('Invalid folder URL');
      return;
    }

    const apiUrl = `${ManagerlApi}/tiling/${folderId}`;
    console.log(apiUrl);

    // Set current folderId and trigger the check mark display
    setCurrentFolderId(folderId);
    setShowCheckMark(false);

    // Add the request to the list with start time and default status
    const requestId = uuidv4();

    // Get current date and time
    const startTime = new Date().toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });

    setRequests((prevRequests) => [
      ...prevRequests,
      {
        id: requestId,
        folderId,
        status: 'In Progress',
        startTime,  // Record the start time
        loading: true,
      },
    ]);

    setFolderPath(''); // Clear the folder path input immediately

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // Update the request status in the list with response message
      const statusMessage = response.data.message || 'Task Completed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${statusMessage} ✅`, loading: false }
            : request
        )
      );
    } catch (error) {
      console.error('There was an error running Las Divider!', error);

      // Update the request status in the list with error message
      const errorMessage = error.response?.data?.message || 'Task Failed';
      setRequests((prevRequests) =>
        prevRequests.map((request) =>
          request.id === requestId
            ? { ...request, status: `${errorMessage} ❌`, loading: false }
            : request
        )
      );
    }
  };

  const handleDeleteRequest = (id) => {
    setRequests((prevRequests) =>
      prevRequests.filter((request) => request.id !== id)
    );
  };

  const handleClearAll = () => {
    setRequests([]);
  };

  useEffect(() => {
    setRunLasDivider(() => handleRunLasDivider);
  }, [folderPath, setRunLasDivider]);

  return (
    <div>
      <div>
        <label>Folder Path</label>
        <input
          type='text'
          placeholder='Folder Name'
          value={folderPath}
          onChange={(e) => setFolderPath(e.target.value)}
        />
      </div>
      <div>
        <button onClick={handleRunLasDivider}>
          Run Tiling Process
        </button>
      </div>
      {showCheckMark && (
        <div className='check-mark'>Request {currentFolderId} Sent ✅</div>
      )}
      <div className='request-list'>
        <table>
          <thead><br></br>
            Requests
            <tr>
              <th>Folder ID</th>
              <th>Start Time</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((request) => (
              <tr key={request.id}>
                <td>{request.folderId}</td>
                <td>{request.startTime}</td>
                <td>
                  {request.loading ? (
                    <>
                      Running...
                    </>
                  ) : (
                    request.status
                  )}
                </td>
                <td>
                  <button onClick={() => handleDeleteRequest(request.id)}>
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className='clear-all-button' onClick={handleClearAll}>
          Remove All
        </button>
      </div>
    </div>
  );
};

export default LasDividerTab;
